module.exports = __webpack_public_path__ + "static/img/zhongduan.c0943a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/homes/zhongduan.png
// module id = xuL/
// module chunks = 1